import {SalesPerson} from "sharedlibs";
import {SalesPersonFormValues} from "../components/forms/SalesPersonForm";
import {
  addSalesPerson,
  deleteSalesPerson,
  editSalesPerson,
  getSalesPersonById,
  getSalesPersons
} from "../api/salesperson";

export default class SalesPersonService {
  static async getSalesPersonById(id: string): Promise<SalesPerson | undefined> {
    return await getSalesPersonById(id)
  }

  static async getAllSalesPersons(): Promise<SalesPerson[]> {
    return await getSalesPersons()
  }

  static async addSalesPerson(salesPerson: SalesPerson) {
    return await addSalesPerson(salesPerson)
  }

  static async deleteSalesPerson(id: string) {
    await deleteSalesPerson(id)
  }

  static async editSalesPerson(salesPerson: SalesPerson) {
    return await editSalesPerson(salesPerson)
  }

  static mapSalesPersonObjectToFormObject(salesPerson: SalesPerson): SalesPersonFormValues {
    return {
      lastName: salesPerson.lastName,
      disabled: salesPerson.disabled
    };
  }
}
